import React from "react";
import cx from "classnames";
import { SwitchComponent } from "./SwitchModule";
import { Title } from "./TopologyTitle";
import styles from "../WizardResult.module.scss";

const renderSwitches = (items, isTopology = false) =>
  items?.map((item, key) => (
    <SwitchComponent
      key={key}
      {...item}
      {...(isTopology && { isTopology: true })}
    />
  ));

export const TopologySummary = React.memo(
  ({
    title,
    description,
    sameLayer,
    bottomPlacedChildren,
    connectedByTopBracketChildren,
    type,
    ...topology
  }) => (
    <div
      className={cx(
        "d-flex flex-column pt-10 mt-5 mx-auto mb-4",
        styles.summary_view,
      )}
    >
      <div className="w-100 d-flex flex-column px-6 py-4 bg-white mb-10 overflow-auto pb-4">
        <Title
          type={type}
          title={title}
          description={description}
          {...topology}
        />
        {renderSwitches(sameLayer, true)}
        {renderSwitches(bottomPlacedChildren)}
        {renderSwitches(connectedByTopBracketChildren, true)}
      </div>
    </div>
  ),
);
